import { Box, Flex, Td, Tr, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { BsPencil } from "react-icons/bs";
import { MdOutlineDeleteForever } from "react-icons/md";
import { DeleteFollowupModal } from "../Modals/DeleteFollowuplogModal";
import { DateTime } from "luxon";

const experts = [
  { label: "User1", value: "tamannarajpal" },
  { label: "User2", value: "mahi" },
  { label: "User3", value: "divanshi" },
];

const getExpertLabel = (value: string | undefined) => {
  const match = experts.find((e) => e.value === value);
  return match?.label || value;
};

export const FollowupLogsTableRow = ({ el, func }: any) => {
  const {
    _id,
    email,
    assigned_expert,
    channel,
    template,
    original_status,
    current_status,
    createdAt,
  } = el;
  const { isOpen, onOpen, onClose } = useDisclosure();

  const maskEmail = (email: string) => {
    if (!email || !email.includes("@")) return "No email provided";
    const [localPart, domain] = email.split("@");

    const visibleLength = Math.max(0, localPart.length - 4);
    const visiblePart = localPart.slice(0, visibleLength);
    const maskedPart = "*".repeat(Math.min(4, localPart.length));

    return `${visiblePart}${maskedPart}@${domain}`;
  };

  const followupDateTime = DateTime.fromISO(createdAt).setZone("local");

  const [modal, setModal] = useState("");
  return (
    <Tr>
      <Td px={2} borderBottom="1px solid gray">
        {/* {maskEmail(email)} */}
        {email}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {getExpertLabel(assigned_expert?.split("_")[1])}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {channel}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {template}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {original_status}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {current_status}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        {followupDateTime.toFormat("yyyy-MM-dd")} &nbsp;&nbsp;
        {followupDateTime.toFormat("hh:mm a")}
      </Td>
      <Td px={2} borderBottom="1px solid gray">
        <span title="Delete">
          <MdOutlineDeleteForever
            className="deleteButton pointer"
            onClick={() => {
              setModal("deletemodal");
              onOpen();
            }}
          />
        </span>
      </Td>
      {modal === "deletemodal" && (
        <DeleteFollowupModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={_id}
        />
      )}
    </Tr>
  );
};
